import { defineStore } from 'pinia'
// @ts-ignore
import { ref, computed } from 'vue'
import firmService from '@/services/firmService'

export const useFirmStore = defineStore('firm', () => {
  // State
  const selectedFirm = ref<any>(null)

  // Getters
  const getSelectedFirm = computed(() => selectedFirm.value)

  // Actions
  function selectFirm(firm: any) {
    selectedFirm.value = firm
  }

  function clearSelectedFirm() {
    selectedFirm.value = null
  }

  // Load user's firm data
  async function loadUserFirm() {
    // Only load firm data if authenticated and not already loaded
    if (selectedFirm.value) {
      return true
    }
    
    try {
      console.log('Loading user firm data for FIRM_OWNER...')
      const firmData = await firmService.getMyFirm()
      
      if (firmData) {
        console.log('Firm data loaded successfully:', firmData.name)
        selectFirm(firmData)
        return true
      } else {
        console.log('No firm data found for user')
        return false
      }
    } catch (error) {
      console.error('Error loading user firm:', error)
      return false
    }
  }

  return {
    // State
    selectedFirm,
    
    // Getters
    getSelectedFirm,
    
    // Actions
    selectFirm,
    clearSelectedFirm,
    loadUserFirm
  }
})